export default __webpack_public_path__ + "static/media/categoryImg.187d9700.png";